import React from 'react';
import { CircleExclamationIcon } from '../icons/CircleExclamationIcon';
const ErrorMessage = ({ message }) => (React.createElement("div", { className: 'cb-error-message' },
    React.createElement("div", { className: 'cb-error-message-icon-container' },
        React.createElement(CircleExclamationIcon, { className: 'cb-error-message-icon' })),
    React.createElement("div", { className: 'cb-error-message-text' }, message)));
export default ErrorMessage;
